import { render, staticRenderFns } from "./ModalStaff.vue?vue&type=template&id=bcab4450"
import script from "./ModalStaff.vue?vue&type=script&lang=js"
export * from "./ModalStaff.vue?vue&type=script&lang=js"
import style0 from "./ModalStaff.vue?vue&type=style&index=0&id=bcab4450&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcab4450')) {
      api.createRecord('bcab4450', component.options)
    } else {
      api.reload('bcab4450', component.options)
    }
    module.hot.accept("./ModalStaff.vue?vue&type=template&id=bcab4450", function () {
      api.rerender('bcab4450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/corredurias/ModalStaff.vue"
export default component.exports